import type { clientTypes } from '@bedc/client/types';

import { getBrandAssetPath, getBrandProfile } from './brandUtils';

/**
 * Apply session presentation only; installed-app and push identity remain deployment-owned.
 *
 * @param id The brand ID to apply.
 */
export function applyBrand(id: clientTypes.brand.Id) {
	const brand = getBrandProfile(id);
	const assetPath = getBrandAssetPath(id);
	document.documentElement.dataset.brand = id;
	document.documentElement.dataset.accent = brand.theme;
	document.title = brand.name;
	document.querySelector('meta[name="theme-color"]')?.setAttribute('content', brand.themeColor);
	for (const size of [16, 32]) {
		document
			.querySelector(`link[rel="icon"][sizes="${size}x${size}"]`)
			?.setAttribute('href', `${assetPath}/favicon-${size}x${size}.png`);
	}
	const mask = document.querySelector('link[rel="mask-icon"]');
	mask?.setAttribute('href', `${assetPath}/safari-pinned-tab.svg`);
	mask?.setAttribute('color', brand.themeColor);
}
